<template>
  <v-data-table
    :search="searchTable"
    v-if="this.userLogin.company_id != 0 || this.userLogin.roles[0].name == 'super_admin'"
    :headers="headers"
    :items="item_belanja"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>List Belanja</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-text-field
          v-model="searchTable"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="80%" scrollable>
          <template v-if="permission.includes('Create Belanja') && (maksPending == 0 || totalPending < maksPending)" v-slot:activator="{ on }">
            <v-btn
              color="primary"
              small
              dark
              class="mb-2"
              v-on="on"
              @click="[isSaved = false]"
            >Buat Pengajuan Belanja</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-layout row wrap>
                <v-flex class="pl-4 pr-4 pt-4" xs12>
                  <span class="font-weight-bold subtitle-1">PILIH VENDOR</span>
                </v-flex>
                <v-flex class="pl-4 pr-4 pt-4" xs6 v-if="editedIndex == -1">
                  <v-text-field hint="Tekan Enter untuk mencari vendor" persistent-hint v-model="inputSearch" @keyup.enter="searchUser" label="Masukkan Email / Telp Vendor"></v-text-field>
                </v-flex>
                <v-flex class="pl-4 pr-4" xs6 v-if="newUser && editedIndex == -1">
                  <v-card width="100%" outlined color="orange darken-1" dark class="white--text">
                    <v-icon class="ma-1">info</v-icon><span style="vertical-align: text-top" class="ma-2 font-weight-bold">Data vendor tidak ditemukan</span>
                    <v-divider></v-divider>
                    <p class="ma-2">Maaf, email atau nomor telepon vendor tidak ditemukan.</p>
                  </v-card>
                </v-flex>
                <v-flex class="pl-4 pr-4" xs6 v-if="!newUser && !userFound && editedIndex == -1">
                  <v-card width="100%" outlined color="blue darken-1" dark class="white--text">
                    <v-icon class="ma-1">info</v-icon><span style="vertical-align: text-top" class="ma-2 caption">Cari Data Vendor</span>
                    <v-divider></v-divider>
                    <p class="ma-2 caption">Masukkan email atau telepon vendor.</p>
                  </v-card>
                </v-flex>
                <v-flex class="pl-4 pr-4" xs6 v-if="newUser">
                  <v-text-field v-model="editedItemUser.name" label="Name"></v-text-field>
                </v-flex>
                <!-- <v-flex class="pl-4 pr-4" xs6 v-if="newUser">
                  <v-text-field v-model="editedItemUser.username" label="Username"></v-text-field>
                </v-flex> -->
                <v-flex class="pl-4 pr-4" xs6 v-if="newUser">
                  <v-text-field v-model="editedItemUser.email" label="Email"></v-text-field>
                </v-flex>
                <v-flex class="pl-4 pr-4" xs6 v-if="newUser">
                  <v-text-field v-model="editedItemUser.telp" label="Telp"></v-text-field>
                </v-flex>
                <v-flex class="pl-4 pr-4" xs6 v-if="newUser">                    
                  <v-autocomplete
                    v-model="editedItemUser.roles[0].id"
                    :items="roles"
                    item-text='name'
                    item-value='id'
                    label="Choose a Role"
                  ></v-autocomplete>
                </v-flex>
                <!-- <v-flex class="pl-4 pr-4" xs6 v-if="newUser">
                  <v-text-field type="password" v-model="editedItemUser.password" label="Password"></v-text-field>
                </v-flex>
                <v-flex class="pl-4 pr-4" xs6 v-if="newUser">
                  <v-text-field type="password" v-model="editedItemUser.password_conf" label="Confirmation"></v-text-field>
                </v-flex> -->
                <v-flex class="pl-4 pr-4" xs6 v-if="userFound">
                  <v-card width="100%" outlined color="green darken-1" dark class="white--text">
                    <v-icon class="ma-1">info</v-icon><span style="vertical-align: text-top" class="ma-2 font-weight-bold">Data Vendor Ditemukan</span>
                    <v-divider></v-divider>
                    <p class="ma-2">Nama: {{ editedItemUser.name }}</p>
                    <p class="ma-2">Email: {{ editedItemUser.email }}</p>
                    <p class="ma-2">Phone: {{ editedItemUser.telp }}</p>
                  </v-card>
                </v-flex>
                <v-flex class="pl-4 pr-4 pt-8" xs12>
                  <span class="font-weight-bold subtitle-1">DETAIL BELANJA</span>
                </v-flex>
                <v-flex class="pl-4 pr-4" xs12>
                  <v-text-field v-model="editedItem.name" label="Nama Belanja" required></v-text-field>
                </v-flex>
                <v-flex class="pl-4 pr-4" xs12 v-if="role == 'stockiest'">
                  <v-text-field v-model="editedItem.keterangan" label="Keterangan Belanja" required></v-text-field>
                </v-flex>
                <v-flex class="pl-4 pr-4" xs6>
                  <v-text-field v-model="editedItem.date" type="datetime-local" label="Tanggal" required></v-text-field>
                </v-flex>
                <v-flex class="pl-4 pr-4" xs6>
                  <v-text-field v-model="editedItem.due_date" type="datetime-local" label="Batas Waktu" required></v-text-field>
                </v-flex>
                <v-flex class="pl-4 mt-3 pr-4" xs12>
                  <h6>List Items</h6>
                  <template>
                    <v-data-table :headers="headerListItems" :items="items">
                      <template v-slot:[`item.harga_beli`]="props">
                        <div
                          v-if="role !== 'purchasing'"
                        >{{ convertCurrency(props.item.harga_beli) }}</div>
                        <v-edit-dialog
                          :return-value.sync="props.item.harga_beli"
                          large
                          persistent
                          @save="editableSave"
                          @cancel="editableCancel"
                          @open="editableOpen"
                          @close="editableClose"
                          v-if="role == 'purchasing'"
                        >
                          <div>{{ convertCurrency(props.item.harga_beli) }}</div>
                          <template v-slot:input>
                            <div class="mt-4 title">Update Price</div>
                          </template>
                          <template v-slot:[`input`]>
                            <v-text-field
                              v-model="props.item.harga_beli"
                              label="Edit"
                              single-line
                              counter
                              autofocus
                            ></v-text-field>
                          </template>
                        </v-edit-dialog>
                      </template>
                      <template v-slot:[`item.ppn`]="props">
                        <div
                          v-if="role !== 'purchasing'"
                        >{{ props.item.ppn }}</div>
                        <v-edit-dialog
                          :return-value.sync="props.item.ppn"
                          large
                          persistent
                          @save="editableSave"
                          @cancel="editableCancel"
                          @open="editableOpen"
                          @close="editableClose"
                          v-if="role == 'purchasing'"
                        >
                          <div>{{ props.item.ppn }}</div>
                          <template v-slot:input>
                            <div class="mt-4 title">Update PPN</div>
                          </template>
                          <template v-slot:[`input`]>
                            <v-text-field
                              v-model="props.item.ppn"
                              label="Edit"
                              single-line
                              counter
                              autofocus
                            ></v-text-field>
                          </template>
                        </v-edit-dialog>
                      </template>
                      <template v-slot:[`item.discount`]="props">
                        <div
                          v-if="role !== 'purchasing'"
                        >{{ props.item.discount }}</div>
                        <v-edit-dialog
                          :return-value.sync="props.item.discount"
                          large
                          persistent
                          @save="editableSave"
                          @cancel="editableCancel"
                          @open="editableOpen"
                          @close="editableClose"
                          v-if="role == 'purchasing'"
                        >
                          <div>{{ props.item.discount }}</div>
                          <template v-slot:input>
                            <div class="mt-4 title">Update Discount</div>
                          </template>
                          <template v-slot:[`input`]>
                            <v-text-field
                              v-model="props.item.discount"
                              label="Edit"
                              single-line
                              counter
                              autofocus
                            ></v-text-field>
                          </template>
                        </v-edit-dialog>
                      </template>
                      <template v-slot:[`item.no`]="{ item }">
                        {{(items.indexOf(item)+1) + '.'}}
                      </template>
                      <template v-slot:[`item.action`]="props" v-if="permission.includes('Create Belanja') || permission.includes('Update Belanja')">
                        <v-btn icon color="red" slot="activator" @click="removeItem(props.item)">
                          <v-icon>delete</v-icon>
                        </v-btn>
                      </template>
                    </v-data-table>

                    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
                      {{ snackText }}
                      <v-btn text @click="snack = false">Close</v-btn>
                    </v-snackbar>
                  </template>
                </v-flex>
                <v-expansion-panels class="pl-4 mt-3 pr-4">
                  <v-expansion-panel>
                    <v-expansion-panel-header>Tambah Item</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-flex class="pl-4" xs12>
                        <v-layout row wrap align-center>
                          <v-flex xs3 class="pl-4 pr-4 pb-0">
                            <suggestions
                              v-model="searchQuery"
                              :options="options"
                              :onItemSelected="onSearchItemSelected"
                              :onInputChange="onInputChange"
                            >
                              <div slot="item" slot-scope="props" class="single-item">
                                <template v-if="props.item.Icon && props.item.Icon.URL">
                                  <div
                                    class="image-wrap"
                                    :style="{'backgroundImage': 'url('+ props.item.Icon.URL + ')' }"
                                  ></div>
                                </template>
                                <span class="name">{{props.item.name}}</span>
                              </div>
                            </suggestions>
                          </v-flex>
                          <v-flex xs2 class="pl-4 pr-4">
                            <v-text-field
                              type="number"
                              v-model="inputItem.qty"
                              label="Jumlah"
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs2 class="pl-4 pr-4">
                            <div class="v-input v-input--is-label-active v-input--is-dirty theme--light v-text-field v-text-field--is-booted">
                              <div class="v-input__control">
                                <div class="v-input__slot">
                                  <div class="v-text-field__slot">
                                    <label for="customElement1" class="v-label v-label--active theme--light" style="left: 0px; right: auto; position: absolute;">Harga</label>
                                    <money :disabled="isDisabled('stockiest')" v-model="inputItem.harga_beli" id="customElement1"></money>
                                  </div>
                                </div>
                                <div class="v-text-field__details">
                                  <div class="v-messages theme--light">
                                    <div class="v-messages__wrapper">
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!-- <v-text-field
                              type="number"
                              v-model="inputItem.harga_beli"
                              :disabled="isDisabled('stockiest')"
                              label="Harga"
                              required
                            ></v-text-field> -->
                          </v-flex>
                          <v-flex xs2 class="pl-4 pr-4">
                            <v-text-field
                              type="number"
                              v-model="inputItem.discount"
                              :disabled="isDisabled('stockiest')"
                              label="Discount"
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs2 class="pl-4 pr-4">
                            <v-text-field
                              type="number"
                              v-model="inputItem.ppn"
                              :disabled="isDisabled('stockiest')"
                              label="PPN"
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs1 class="pl-4 pr-4" v-if="searchQuery!='' && inputItem.qty!='' && inputItem.harga_beli!=='' && inputItem.product_id !== 0">
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  small
                                  icon
                                  color="green"
                                  slot="activator"
                                  v-on="on"
                                  @click="addItem()"
                                >
                                  <v-icon>check</v-icon>
                                </v-btn>
                              </template>
                              <span>Tambahkan Item</span>
                            </v-tooltip>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-layout>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="orange darken-3" text @click="close">Cancel</v-btn>
              <v-btn v-if="items.length > 0" color="blue darken-1" text @click="save">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogNote" max-width="500px" persistent>
          <v-card>
            <v-card-title>
              <span class="headline">Catatan</span>
            </v-card-title>
            <v-card-text>{{note}}</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="dialogNote = false">Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogApproval" max-width="500px" persistent>
          <v-card>
            <v-card-title>
              <span class="headline">Catatan {{approval}}</span>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="6" md="12">
                  <v-text-field v-model="note" label="Catatan" required></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeApproval()">Tidak</v-btn>
              <v-btn color="blue darken-1" text @click="saveApproval(approval)">Ya</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogFulfilled" max-width="500px" persistent>
          <v-card>
            <v-card-text>
              <v-row>
                <v-col cols="12" md="12">
                  <h4>{{dialogTextEditedFulfilled}}</h4>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeFulfilled()">Tidak</v-btn>
              <v-btn color="blue darken-1" text @click="saveFulfilled()">Ya</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog
          v-model="dialog2"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
          scrollable
        >
          <v-card tile>
            <v-toolbar flat dark class="grey darken-2 text-center" style="max-height: 64px">
              <v-toolbar-title>Purchase Order</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon dark @click="[dialog2 = false,expand = false,editedIndex = -1]">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-row>
                <v-col cols="8" sm="4" md="8"></v-col>
                <v-col cols="4" sm="2" md="4">
                  <p
                    class="font-weight-bold"
                  >{{dataUserInvoice.company == null ? 'Tidak ada nama' : dataUserInvoice.company.name}}</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="8" sm="4" md="8"></v-col>
                <v-col
                  cols="4"
                  sm="2"
                  md="4"
                >{{dataUserInvoice.company == null ? 'Tidak ada nama' : dataUserInvoice.company.email}}</v-col>
              </v-row>
              <v-divider class="pb-3"></v-divider>
              <v-row>
                <v-col class="pa-0 pl-3" cols="2" sm="1" md="2">
                  <p class="font-weight-bold">Nama Vendor:</p>
                </v-col>
                <v-col class="pa-0 pl-3" cols="2" sm="1" md="2">
                  <p
                    class="text-left"
                  >{{dataDetails.customer == null ? 'Tidak ada nama vendor' : dataDetails.customer.name}}</p>
                </v-col>
                <v-col cols="4" sm="2" md="4" class="text-center pa-0">
                  <template v-if="dataDetails.status == 'PAID'">
                    <v-chip class="mb-2" color="green" label outlined>
                      <v-icon left>monetization_on</v-icon>
                      {{dataDetails.status}}
                    </v-chip>
                  </template>
                  <template v-else-if="dataDetails.status == 'PARTIAL'">
                    <v-chip class="mb-2" color="yellow darken-2" label outlined>
                      <v-icon left>monetization_on</v-icon>
                      {{dataDetails.status}}
                    </v-chip>
                  </template>
                  <template v-else-if="dataDetails.status == 'APPROVED'">
                    <v-chip class="mb-2" color="green" label outlined>
                      <v-icon left>check_circle</v-icon>
                      {{dataDetails.status}}
                    </v-chip>
                  </template>
                  <template v-else-if="dataDetails.status == 'PENDING'">
                    <v-chip class="mb-2" color="yellow darken-2" label outlined>
                      <v-icon left>queue</v-icon>
                      {{dataDetails.status}}
                    </v-chip>
                  </template>
                  <template v-else-if="dataDetails.status == 'REJECTED'">
                    <v-chip class="mb-2" color="red darken-2" label outlined>
                      <v-icon left>cancel</v-icon>
                      {{dataDetails.status}}
                    </v-chip>
                  </template>
                  <template v-else-if="dataDetails.status == 'COMPLETED'">
                    <v-chip class="mb-2" color="green" label outlined>
                      <v-icon left>check_box</v-icon>
                      {{dataDetails.status}}
                    </v-chip>
                  </template>
                </v-col>
                <v-col class="pa-0 pl-3" cols="2" sm="1" md="2">
                  <p class="font-weight-bold">Nama Petugas:</p>
                </v-col>
                <v-col class="pa-0 pr-3" cols="2" sm="1" md="2">
                  <p
                    class="text-right"
                  >{{dataDetails.user == null ? 'Tidak ada nama petugas' : dataDetails.user.name}}</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pa-0 pl-3" cols="2" sm="1" md="2">
                  <p class="font-weight-bold">Telp Vendor:</p>
                </v-col>
                <v-col class="pa-0 pl-3" cols="2" sm="1" md="2">
                  <p
                    class="text-left"
                  >{{dataDetails.customer == null ? 'Tidak ada telpon vendor' : dataDetails.customer.telp}}</p>
                </v-col>
                <v-col cols="4" sm="2" md="4" class="text-center"></v-col>
                <v-col class="pa-0 pl-3" cols="2" sm="1" md="2">
                  <p class="font-weight-bold">Purchase Number:</p>
                </v-col>
                <v-col class="pa-0 pr-3" cols="2" sm="1" md="2">
                  <p class="text-right">{{dataDetails.id}}</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pa-0 pl-3" cols="2" sm="1" md="2">
                  <p class="font-weight-bold">Tanggal Purchase:</p>
                </v-col>
                <v-col class="pa-0 pl-3" cols="2" sm="1" md="2">
                  <p class="text-left">{{dataDetails.date}}</p>
                </v-col>
                <v-col cols="4" sm="2" md="4" class="text-center pa-0"></v-col>
                <v-col class="pa-0 pl-3" cols="2" sm="1" md="2">
                  <p class="font-weight-bold">Jumlah Pesanan:</p>
                </v-col>
                <v-col class="pa-0 pr-3" cols="2" sm="1" md="2">
                  <p class="text-right">{{dataDetails.items.length}}</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pa-0 pl-3" cols="2" sm="1" md="2">
                  <p class="font-weight-bold">Keterangan Belanja:</p>
                </v-col>
                <v-col class="pa-0 pl-3" cols="2" sm="1" md="2">
                  <p class="text-left">{{dataDetails.keterangan == null ? 'Tidak ada keterangan' : dataDetails.keterangan}}</p>
                </v-col>
                <v-col cols="4" sm="2" md="4" class="text-center pa-0">
                </v-col>
                <v-col class="pa-0 pl-3" cols="2" sm="1" md="2">
                  <p class="font-weight-bold">No. Dokumen Rujukan:</p>
                </v-col>
                <v-col class="pa-0 pr-3" cols="2" sm="1" md="2">
                  <p class="text-right">{{dataDetails.note == null ? 'Tidak ada catatan' : dataDetails.note}}</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pa-0 pl-3" cols="2" sm="1" md="2">
                  <p class="font-weight-bold">Nama Belanja:</p>
                </v-col>
                <v-col class="pa-0 pl-3" cols="2" sm="1" md="2">
                  <p
                    class="text-left"
                  >{{dataDetails.name == null ? 'Tidak ada nama' : dataDetails.name}}</p>
                </v-col>
                <v-col cols="4" sm="2" md="4" class="text-center pa-0"></v-col>
                <v-col class="pa-0 pl-3" cols="2" sm="1" md="2">
                </v-col>
                <v-col class="pa-0 pr-3" cols="2" sm="1" md="2">
                </v-col>
              </v-row>
              <v-simple-table fixed-header max-height="300px" class="mb-4">
                <template>
                  <thead class="grey lighten-4">
                    <tr>
                      <td
                        v-for="header in headerSubItem"
                        :key="header.text"
                        :class="header.align"
                      >{{ header.text }}</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(subItem, index) in dataDetails.items" :key="subItem.id">
                      <td class="text-left">{{ index+1 }}.</td>
                      <td class="text-left">{{ subItem.item_name }}</td>
                      <td
                        class="text-center"
                      >{{ (subItem.qty) % 1 == 0 ? (subItem.qty) : (subItem.qty).toFixed(2).replace(".00", "") }}</td>
                      <td class="text-center">{{ convertCurrency(subItem.harga_beli) }}</td>
                      <td class="text-center">
                        <span
                          class="green--text"
                        >{{ (subItem.discount) % 1 == 0 ? (subItem.discount) : (subItem.discount).toFixed(2).replace(".00", "") }}%</span>
                      </td>
                      <td class="text-center">
                        <span
                          class="orange--text"
                        >{{ (subItem.ppn) % 1 == 0 ? (subItem.ppn) : (subItem.ppn).toFixed(2).replace(".00", "") }}%</span>
                      </td>
                      <td class="text-right" v-if="subItem.discount!=0 && subItem.ppn!=0">
                        {{ (( ((subItem.qty)*((subItem.harga_beli))) * (1-(subItem.discount/100)) ) * (1+(subItem.ppn/100))) % 1 == 0 ?
                        convertCurrency(( ((subItem.qty)*((subItem.harga_beli))) * (1-(subItem.discount/100)) ) * (1+(subItem.ppn/100))) :
                        convertCurrency((( ((subItem.qty)*((subItem.harga_beli))) * (1-(subItem.discount/100)) ) * (1+(subItem.ppn/100))).toFixed(4).replace(".0000", "")) }}
                      </td>
                      <td class="text-right" v-else-if="subItem.discount!=0">
                        {{ (( ((subItem.qty)*((subItem.harga_beli))) * (1-(subItem.discount/100)) )) % 1 == 0 ?
                        convertCurrency(( ((subItem.qty)*((subItem.harga_beli))) * (1-(subItem.discount/100)) )) :
                        convertCurrency((((subItem.qty)*((subItem.harga_beli))) * (1-(subItem.discount/100))).toFixed(4).replace(".0000", ""))}}
                      </td>
                      <td class="text-right" v-else-if="subItem.ppn!=0">
                        {{ (( ((subItem.qty)*((subItem.harga_beli))) * (1+(subItem.ppn/100)) )) % 1 == 0 ? 
                        convertCurrency(( ((subItem.qty)*((subItem.harga_beli))) * (1+(subItem.ppn/100)) )) : 
                        convertCurrency((((subItem.qty)*((subItem.harga_beli))) * (1+(subItem.ppn/100))).toFixed(4).replace(".0000", ""))}}
                      </td>
                      <td class="text-right" v-else>
                        {{ ((subItem.qty)*((subItem.harga_beli))) % 1 == 0 ? 
                        convertCurrency((subItem.qty)*((subItem.harga_beli))) : 
                        convertCurrency(((subItem.qty)*((subItem.harga_beli))).toFixed(4).replace(".0000", "")) }}
                      </td>
                    </tr>
                    <tr>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>
                        <h6 class="text-right font-weight-bold">Subtotal:</h6>
                      </td>
                      <td class="text-right">{{ convertCurrency(dataDetails.total) }}</td>
                    </tr>
                    <tr v-if="paid > 0">
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>
                        <h6 class="text-right font-weight-bold green--text">Dibayar:</h6>
                      </td>
                      <td class="text-right green--text">{{ convertCurrency(paid) }}</td>
                    </tr>
                    <tr>
                      <td colspan="5">
                        <v-btn
                          v-if="dataDetails.status != 'REJECTED'"
                          class="ma-2"
                          small
                          color="primary"
                          @click="expand = !expand"
                        >
                          <v-icon class="mr-2">history</v-icon>Riwayat Pencairan
                        </v-btn>
                        <v-btn
                          v-if="dataDetails.status == 'PAID' && role == 'purchasing' && dataDetails.is_fulfilled === 1"
                          class="ma-2"
                          small
                          color="success"
                          @click="completeSubmission()"
                        >
                          <v-icon class="mr-2">done</v-icon>P.O. Selesai
                        </v-btn>
                        <v-btn 
                          class="ma-2"
                          small
                          color="orange darken-2"
                          style="color: #fff;"
                          @click="expandNotes = !expandNotes">
                          <md-icon class="mr-2" style="color: #fff;">speaker_notes</md-icon> Riwayat Catatan
                        </v-btn> 
                      </td>
                      <td v-if="dataDetails.total - paid > 0 && paid > 0">
                        <h6 class="text-right font-weight-bold">Total:</h6>
                      </td>
                      <td
                        v-if="dataDetails.total - paid > 0 && paid > 0"
                        class="text-right"
                      >{{ convertCurrency(dataDetails.total - paid) }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-expand-transition>
                <v-card v-show="expand" outlined>
                  <p class="text-center font-weight-bold" style="margin: 30px 0px">RIWAYAT PENCAIRAN</p>
                  <v-simple-table fixed-header>
                    <template>
                      <thead class="grey lighten-4">
                        <tr>
                          <td
                            v-for="header in headerPaymentHistory"
                            :key="header.text"
                          >{{ header.text }}</td>
                        </tr>
                      </thead>
                      <tbody v-if=" paymentItems != null">
                        <tr v-for="(subItem, index) in paymentItems" :key="subItem.id">
                          <!-- <td>{{ new Date(subItem.tanggal).toLocaleDateString('id') }}</td> -->
                          <td style="width: 10px">{{ Number(index)+1 }}.</td>
                          <td>{{ subItem.tanggal }}</td>
                          <td>{{ convertCurrency(Number(subItem.jumlah)) }}</td>
                          <td>{{ subItem.payment_method ? subItem.payment_method.name : '-' }}</td>
                          <td>
                            <v-icon
                              v-if="dataDetails.status != 'COMPLETED' && role == 'accountant'"
                              small
                              class="mr-2"
                              @click="deletePayment(subItem)"
                            >delete</v-icon>
                            <p v-else>-</p>
                          </td>
                        </tr>
                      </tbody>
                      <tbody v-else>
                        <tr>
                          <td colspan="5">
                            <p class="font-weight-bold">No data available.</p>
                          </td>
                        </tr>
                      </tbody>
                      <v-btn
                        v-if="Number(dataDetails.total) > paid && (dataDetails.status == 'APPROVED' || dataDetails.status == 'PARTIAL') && role == 'accountant'"
                        small
                        class="white--text"
                        style="margin: 10px"
                        color="green"
                        @click="[dialog3 = true, jumlahPayment = Number(dataDetails.total) - paid]"
                      >
                        <v-icon>add</v-icon>TAMBAH PENCAIRAN
                      </v-btn>
                    </template>
                  </v-simple-table>
                </v-card>
              </v-expand-transition>
              <v-expand-transition>
                <v-card
                  v-show="expandNotes"
                  outlined
                >
                  <p class="text-center font-weight-bold" style="margin: 30px 0px">RIWAYAT CATATAN</p>
                  <v-simple-table fixed-header>
                    <template>
                      <thead class="grey lighten-4">
                        <tr>
                          <td v-for="header in headerNotes" :key="header.text">{{ header.text }}</td>
                        </tr>
                      </thead>
                      <tbody v-if="submissionNotes != null">
                        <tr v-for="(note, index) in submissionNotes" :key="note.id">
                          <td style="width:10px">{{ Number(index)+1 }}.</td>
                          <td>{{ note.comment }}</td>
                          <td>{{ note.user.name }}</td>
                          <td>{{ note.date }}</td>
                          <td>
                            <v-icon v-if="userLogin.id === note.user.id" small class="mr-2" @click="handleDeleteSubmissionNote(note.id, index)">delete</v-icon>
                          </td>
                        </tr>
                      </tbody>
                      <tbody v-else>
                        <tr>
                          <td colspan="5"><p class="font-weight-bold">No data available.</p></td>
                        </tr>
                      </tbody>
                      <v-btn
                        small
                        class="white--text"
                        style="margin: 10px"
                        color="green"
                        @click="noteModalVisible = true"
                      >
                        <v-icon >add</v-icon>
                        TAMBAH CATATAN
                      </v-btn>
                    </template>
                  </v-simple-table>
                </v-card>
              </v-expand-transition>
            </v-card-text>
            <div style="flex: 1 1 auto;"></div>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog3" max-width="500px" persistent>
          <v-card>
            <v-card-title>Tambah Pencairan</v-card-title>
            <v-card-text>
              <v-text-field type="datetime-local" v-model="paymentDate" label="Tanggal" required></v-text-field>
              <div class="v-input v-input--is-label-active v-input--is-dirty theme--light v-text-field v-text-field--is-booted">
                <div class="v-input__control">
                  <div class="v-input__slot">
                    <div class="v-text-field__slot">
                      <label for="customElement2" class="v-label v-label--active theme--light" style="left: 0px; right: auto; position: absolute;">Jumlah</label>
                      <money v-model="jumlahPayment" id="customElement2"></money>
                    </div>
                  </div>
                  <div class="v-text-field__details">
                    <div class="v-messages theme--light">
                      <div class="v-messages__wrapper">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <v-text-field type="number" required v-model="jumlahPayment" label="Jumlah"></v-text-field> -->
              <v-select
                v-model="paymentMethodSelected"
                :items="paymentMethod"
                label="Metode Pencairan"
                required
              ></v-select>
              <p
                class="font-italic red--text"
                v-show="showError"
              >*Jumlah pencairan tidak boleh melebihi jumlah pengajuan belanja!</p>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closePayment()">Cancel</v-btn>
              <v-btn color="blue darken-1" text @click="savePayment()">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog
          v-model="noteModalVisible"
          max-width="500px"
          persistent
        >
          <v-card>
            <v-card-title>
              Tambah Catatan
            </v-card-title>
            <v-card-text>
              <v-textarea rows="3" label="Catatan" v-model="newNote.comment" required></v-textarea>
              <v-text-field type="datetime-local" v-model="newNote.date" label="Tanggal"></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="submissionNoteClose()">Cancel</v-btn>
              <v-btn color="blue darken-1" text @click="submissionNoteSave()">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <span class="ml-4 caption red--text font-italic" v-if="role == 'stockiest' && maksPending != 0 && totalPending >= maksPending">*Note: tidak bisa menambahkan pengajuan belanja baru karena sudah mencapai batas maksimum {{maksPending}} pending belanja <br/> <span class="ml-4">*Minta tolong admin dan accountant untuk segera approve belanja</span></span>
      <v-row class="ml-2 mt-4">
        <v-col class="d-flex" cols="3">
          <v-select
            v-model="selectedStatus"
            :items="listStatus"
            label="Filter Status"
            @click:clear="clearFilterStatus"
            @change="changeFilter"
            clearable dense outlined
            prepend-icon="mdi-filter"
          ></v-select>
        </v-col>
        <v-col class="d-flex">
          &nbsp;
        </v-col>
        <v-col class="d-flex mr-2">
          <v-text-field type="datetime-local" clearable v-model="selectedDateFrom" @change="changeFilter" label="Tanggal Mulai"></v-text-field>
        </v-col>
        <v-col class="d-flex mr-2">
          <v-text-field type="datetime-local" clearable v-model="selectedDateTo" @change="changeFilter" label="Tanggal Selesai"></v-text-field>
        </v-col>
      </v-row>
    </template>
    <template v-slot:[`item.date`]="{ item }">
      {{formatdate(item.date)}}
    </template>
    <template v-slot:[`item.status`]="{ item }">
      <v-chip small class="ma-2" label :text-color="statusTextColor[item.status.replace(/\s/g, '')]" :color="statusColor[item.status.replace(/\s/g, '')]">{{ item.status}}</v-chip>
    </template>
    <template v-slot:[`item.no`]="{ item }">
      {{(item_belanja.indexOf(item)+1) + '.'}}
    </template>
    <template v-slot:[`item.is_fulfilled`]="{ item }">
      <v-chip small class="ma-2" label style="color: #fff;" :color="item.is_fulfilled ? '#27ae60' : '#fa8231'">{{ item.is_fulfilled ? "Fulfilled" : "Sedang diproses"}}</v-chip>
    </template>
    <template v-slot:[`item.total`]="{ item }">{{convertCurrency(item.total)}}</template>
    <template v-if="role == 'accountant'" v-slot:[`item.action`]="{ item }">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-icon
            v-show="item.status == 'PENDING'"
            small
            class="mr-2"
            v-on="on"
            @click="editStatusApprove(item)"
          >done_outline</v-icon>
        </template>
        <span>Approve</span>
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-icon
            v-show="item.status == 'PENDING'"
            small
            class="mr-2"
            v-on="on"
            @click="editStatusRefuse(item)"
          >cancel</v-icon>
        </template>
        <span>Reject</span>
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-icon
            v-show="item.status=='APPROVED' || item.status=='PARTIAL' || item.status=='PAID' || item.status=='COMPLETED'"
            class="mr-2"
            small
            v-on="on"
            @click="onClickPrint(item)"
          >print</v-icon>
        </template>
        <span>Print</span>
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-icon
            v-show="item.status!='PENDING' && item.status!='PARTIAL APPROVED' && item.status!='COMPLETED'"
            v-on="on"
            class="mr-2"
            small
            @click="noteModalEdited(item)"
          >announcement</v-icon>
        </template>
        <span>Catatan</span>
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-icon small class="mr-2" v-on="on" @click="modalDetail(item)">info</v-icon>
        </template>
        <span>Detail</span>
      </v-tooltip>
      <v-icon v-show="item.status=='PENDING' && permission.includes('Delete Belanja')" small @click="deleteItem(item)">delete</v-icon>
    </template>
    <template v-else v-slot:[`item.action`]="{ item }">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-icon v-show="item.status == 'PARTIAL APPROVED' && role === 'admin'" small class="mr-2" v-on="on" @click="editStatusApprove(item)">done_outline</v-icon>
        </template>
        <span>Approve</span>
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-icon
            v-show="statusCanEdit.includes(item.status) && permission.includes('Update Belanja')"
            v-on="on"
            small
            class="mr-2"
            @click="editItem(item)"
          >edit</v-icon>
        </template>
        <span>Edit</span>
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-icon
            v-show="(item.status == 'APPROVED' || item.status == 'PARTIAL' || item.status == 'PAID' || item.status == 'COMPLETED') && item.is_fulfilled === 0 && role == 'stockiest'"
            small
            class="mr-2"
            v-on="on"
            @click="editStatusFulfilled(item,'ACCEPT_FULFILLED')"
          >done_outline</v-icon>
        </template>
        <span>Fulfilled</span>
      </v-tooltip>
      <!-- <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-icon
            v-show="(item.status == 'APPROVED' || item.status == 'PARTIAL' || item.status == 'PAID' || item.status == 'COMPLETED') && item.is_fulfilled === 1 && role == 'stockiest'"
            small
            class="mr-2"
            v-on="on"
            @click="editStatusFulfilled(item,'CANCEL_FULFILLED')"
          >cancel</v-icon>
        </template>
        <span>Fulfilled</span>
      </v-tooltip> -->
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-icon
            v-show="item.status=='APPROVED' || item.status=='PARTIAL' || item.status=='PAID' || item.status=='COMPLETED'"
            class="mr-2"
            small
            v-on="on"
            @click="onClickPrint(item)"
          >print</v-icon>
        </template>
        <span>Print</span>
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-icon small class="mr-2" v-on="on" @click="modalDetail(item)">info</v-icon>
        </template>
        <span>Detail</span>
      </v-tooltip>
      <v-icon v-show="item.status=='PENDING' && permission.includes('Delete Belanja')" small @click="deleteItem(item)">delete</v-icon>
      <!-- <v-icon v-show="item.status=='REJECTED' || item.status=='APPROVED'" class="mr-2" small @click="noteModal(item)">announcement</v-icon> -->
    </template>
    <template v-slot:no-data>
      <span class="text-center">No data available.</span>
    </template>
    <template v-slot:footer>
      <v-divider></v-divider>
      <div style="padding:0 5em;">
        <div :class="`d-flex justify-end`">
          <h5>Total Belanja: <b style="color: #E53935;">{{convertCurrency(totalBelanja)}}</b></h5>
        </div>
      </div>
    </template>
  </v-data-table>
  <div v-else class="content">
    <div class="md-layout">
      <nav-tabs-card>
        <template slot="content">
          <h3 class="text-center">Silahkan tambahkan data company profile terlebih dahulu</h3>
        </template>
      </nav-tabs-card>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import {forEach,slice,isEmpty,orderBy,find,countBy} from "lodash";
import debounce from "debounce";
import dayjs from "dayjs";
import { NavTabsCard } from "@/components";
import { formatCurrency } from "@/libs/number";
import moment from "moment";

export default {
  components: {
    NavTabsCard
  },
  data: () => ({
    options: {
      placeholder: "Nama Produk",
      debounce: 2000
    },
    isSaved: false,
    dialog2: false,
    dialog3: false,
    dialog: false,
    dialogNote: false,
    dialogApproval: false,
    dialogFulfilled: false,
    dialogDetail: false,
    expand: false,
    userLogin: {},
    note: "",
    approval: "",
    role: "",
    showError: false,
    dataUserInvoice: {},
    permission: [],
    // suggestion product
    searchQuery: "",
    searchTable: '',
    selectedSearchItem: null,
    // end suggestion product
    inputItem: {
      product_id: 0,
      item_name: "",
      harga_beli: "",
      discount: "",
      ppn: "",
      qty: ""
    },
    // search product
    product: "",
    initSearch: null,
    productOptions: [],
    loadingProducts: false,
    onSelectProduct: null,
    // end search product

    // editable component
    snack: false,
    snackColor: "",
    snackText: "",
    pagination: {},

    submissionNotes: null,
    expandNotes: false,
    noteModalVisible: false,
    newNote: {
      comment: '',
      date: dayjs().format("YYYY-MM-DD HH:mm:ss")
    },

    // end editable component
    headers: [
      {
        text: "No.",
        align: "left",
        value: "no",
        filterable: false
      },
      {
        text: "Nama",
        align: "left",
        value: "name"
      },
      { text: "Total Harga", value: "total", filterable: false },
      { text: "Tanggal", value: "date", filterable: false },
      { text: "Status", value: "status", filterable: false },
      {
        text: "Fulfillment",
        align: "left",
        value: "is_fulfilled",
        filterable: false
      },
      { text: "Actions", value: "action", sortable: false, filterable: false }
    ],
    totalBelanja: "Loading...",
    item_belanja: [],
    dataDetails: {
      items: []
    },
    dialogTextEditedFulfilled: "",
    editedIndex: -1,
    editedFulfilled: 0,
    editedItem: {
      // price: "",
      // qty: "",
      total: "",
      partner_id: "",
      date: dayjs().format('YYYY-MM-DD HH:mm:ss'),
      due_date: dayjs().add(7, 'day').format('YYYY-MM-DD HH:mm:ss')
    },
    defaultItem: {
      // price: "",
      // qty: "",
      total: "",
      partner_id: ""
      // date: "",
    },
    items: [],
    paymentItems: null,
    headerListItems: [
      {
        text: "No.",
        align: "left",
        value: "no"
      },
      { text: "Nama Item", align: "text-left", value: "item_name" },
      { text: "Jumlah", align: "text-center", value: "qty" },
      { text: "Harga", align: "text-center", value: "harga_beli" },
      { text: "Diskon", align: "text-center", value: "discount" },
      { text: "PPN", align: "text-center", value: "ppn" },
      { text: "Actions", value: "action", sortable: false }
    ],
    headerSubItem: [
      {
        text: "No.",
        align: "left",
      },
      { text: "Nama Item", align: "text-left" },
      { text: "Jumlah", align: "text-center" },
      { text: "Harga", align: "text-center" },
      { text: "Diskon", align: "text-center" },
      { text: "PPN", align: "text-center" },
      { text: "Total Harga", align: "text-right" }
    ],
    headerPaymentHistory: [
      {
        text: "No.",
        align: "left"
      },
      { text: "Tanggal" },
      { text: "Jumlah" },
      { text: "Metode Pencairan" },
      { text: "Action" }
    ],
    paymentMethod: [],
    headerNotes: [
      {
        text: "No.",
        align: "left",
      },
      { text: "Catatan"},
      { text: "User"},
      { text: "Tanggal"},
      { text: "Action"}
    ],
    paid: 0,
    jumlahPayment: 0,
    paymentMethodSelected: "",
    paymentDate: "",
    paymentRoleDisabled: ["admin","stockiest"],
    statusCanEdit: ["DRAFT", "PENDING", "REJECTED"],
    statusColor: {
      DRAFT: "yellow",
      CANCELED: "red",
      REJECTED: "red",
      FAILED: "red",
      REFUNDED: "orange",
      PENDING: "secondary",
      PARTIAL: "default",
      PAID: "green lighten-1",
      "PARTIALAPPROVED": "blue-grey darken-1",
      APPROVED: "primary",
      COMPLETED: "success"
    },
    statusTextColor: {
      // "DRAFT": "yellow",
      // "CANCELED": "red",
      // "REJECTED": "red",
      // "FAILED": "red",
      // "REFUNDED": "orange",
      // "PENDING": "secondary",
      // "PARTIAL": "default",
      // "PAID": "green lighten-1",
      "PARTIALAPPROVED": "white",
      // "APPROVED": "primary",
      // "COMPLETED": "success"
    },
    maksPending: 0,
    totalPending: 0,
    inputSearch:null,
    newUser:false,
    userFound:false,
    editedItemUser: {
      name: "",
      username: "",
      password: "",
      telp: "",
      email: "",
      roles:[{
        id: "",
        name: ""
      }]
    },
    defaultItemUser: {
      name: "",
      username: "",
      password: "",
      telp: "",
      email: "",
      roles:[{
        id: "",
        name: ""
      }]
    },
    roles:[],
    listStatus: ['DRAFT','PENDING','PARTIAL APPROVED','APPROVED','PARTIAL','PAID','COMPLETED','CANCELED','REFUNDED','FAILED','REJECTED'],
    selectedStatus: null,
    selectedDateFrom: null,
    selectedDateTo: null
  }),

  computed: {
    ...mapGetters({
      dataBelanja: "belanja/getBelanja",
      getRoles: "user/getRoles",
      getSubmissionNote: "submission_note/getSubmissionNoteBySubmissionId"
    }),
    formTitle() {
      return this.editedIndex === -1
        ? "Tambah Pengajuan Belanja"
        : "Edit Pengajuan Belanja";
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    // initSearch(value) {
    //   if (!value) return;
    //   debounce(this.searchProductByName, 5000)(value, this);
    // }
  },

  async created() {
    await this.initialize();
    if(this.$route.query.id != undefined){
      const item = find(this.item_belanja, item => item.id == Number(this.$route.query.id))

      if(item != undefined){
        this.modalDetail(item)
      }

      // console.log('this.route', this.$route)
      // console.log('this.item_pemasukan', this.item_pemasukan)
    }
  },

  methods: {
    formatdate(value){
      return moment(value).format("DD-MM-YYYY HH:mm:ss")
    },
    ...mapMutations({
      setSubmissionId: "submission_note/SET_SUBMISSION_ID"
    }),
    ...mapActions({
      createBelanja: "belanja/createBelanja",
      updateBelanja: "belanja/updateBelanja",
      deleteBelanja: "belanja/deleteBelanja",
      updateStatusBelanja: "belanja/updateStatusBelanja",
      getTransaction: "transaction/getTransactionBySubmissionId",
      createTransaction: "transaction/createTransaction",
      deleteTransaction: "transaction/deleteTransaction",
      getUserById: "user/getUserById",
      getProductByName: "products/getProductByName",
      getMaksimumSubmissions: "user/getMaksimumSubmissions",
      getUsersByEmailOrPhone: "user/getUsersByEmailOrPhone",
      createUserSubmission: "user/createUserSubmission",
      getPaymentMethods: "payment_methods/getPaymentMethods",
      createSubmissionNote: "submission_note/createSubmissionNote",
      deleteSubmissionNote: "submission_note/deleteSubmissionNote",
      filterBelanja: "belanja/filterBelanja"
    }),
    async searchUser(){
      this.userFound = false
      this.newUser = false
      const response = await this.getUsersByEmailOrPhone(this.inputSearch)
      if(response.data != ""){
        this.editedItemUser.id = response.data.id
        this.editedItemUser.name = response.data.name
        this.editedItemUser.email = response.data.email
        this.editedItemUser.telp = response.data.telp
        this.userFound = true
      }else{
        this.editedItemUser.name = ""
        this.editedItemUser.email = ""
        this.editedItemUser.telp = ""
        this.newUser = true
      }
      // console.log('response', response)
    },
    async initialize() {
      this.userLogin = JSON.parse(window.localStorage.getItem("user_data"));
      this.role = this.userLogin.roles[0].name;
      this.permission = this.userLogin.permissions;
      const dataItem = await this.dataBelanja;
      this.totalBelanja = dataItem.total;
      const getRoles = await this.getRoles
      for(let role of getRoles.data.attributes){
        this.roles.push({
            name: role.name == 'unverified' ? 'Personal' : 'Company',
            id: role.id
        })
      }

      forEach(dataItem.submission, (data, index) => {
        forEach(data.items, (subItem, i) => {
          data.items[i].harga_beli = Number(subItem.harga_beli);
          data.items[i].qty = Number(subItem.qty);
          data.items[i].discount = Number(subItem.discount);
          data.items[i].ppn = Number(subItem.ppn);
        });
        data.total = Number(data.total);
        this.item_belanja.push(data);
      });

      const maksimumPending = await this.getMaksimumSubmissions()
      const maksPendingTemp = find(maksimumPending.data.attributes, makpen => makpen.type == 'PENGELUARAN' && makpen.categories_name == 'BELANJA')
      if(maksPendingTemp && maksPendingTemp.jumlah_maksimum > 0){
        this.maksPending = maksPendingTemp.jumlah_maksimum
      }

      const totalPendings = countBy(this.item_belanja, item => item.status == 'PENDING').true
      this.totalPending = (totalPendings == undefined ? 0 : totalPendings )

      const paymentMethodResponse = await this.getPaymentMethods()

      this.paymentMethod = []
      forEach(paymentMethodResponse.data.attributes, (payment, i) => {
        this.paymentMethod.push({
          text: payment.name,
          value: payment.id
        })
      })
    },
    isDisabled(nameRole) {
      if (this.userLogin.roles.find(role => role.name === nameRole)) {
        return true;
      }
      return false;
    },
    convertCurrency(total) {
      return "Rp. " + formatCurrency(total);
    },
    async onInputChange(query) {
      this.inputItem.item_name = ''
      if (query === null || query === "") {
        return "";
      }

      const payload = {
        q: query
      };
      try {
        let response = await this.getProductByName(payload);
        return response.data.attributes;
      } catch (e) {
        self.error = "Unknown Error. Please check details and try again.";
        self.failed();
      }
    },
    onSearchItemSelected(item) {
      this.searchQuery = item.name;
      this.inputItem.product_id = item.id;
      this.inputItem.item_name = item.name;
      this.inputItem.harga_beli = Number(item.harga_beli);
      this.selectedSearchItem = item;

    },
    async inputChange(value) {
      this.search = value;
      if (value != "" && value != null && value.length <= 2) {
        const payload = {
          q: value
        };
        try {
          let response = await this.getProductByName(payload);
          self.productOptions =
            response.data && response.data.attributes
              ? response.data.attributes
              : [];
        } catch (e) {
          self.error = "Unknown Error. Please check details and try again.";
          self.failed();
        }
      }
    },
    // async searchProductByName(value, self) {
    //   if (!value) {
    //     self.productOptions = [];
    //     self.product = "";
    //   }
    //   // if product already requested
    //   if (self.loadingProduct || value.length <= 2) {
    //     return;
    //   }

    //   const payload = {
    //     q: value
    //   };
    //   try {
    //     let response = await this.getProductByName(payload);
    //     self.productOptions =
    //       response.data && response.data.attributes
    //         ? response.data.attributes
    //         : [];
    //   } catch (e) {
    //     self.error = "Unknown Error. Please check details and try again.";
    //     self.failed();
    //   }
    // },

    editItem(data) {
      forEach(data.items, item => {
        item.harga_beli = Number(item.harga_beli);
        item.qty = Number(item.qty);
        item.discount = Number(item.discount);
        item.ppn = Number(item.ppn);
      });
      this.items = data.items;
      this.editedIndex = this.item_belanja.indexOf(data);
      this.editedItem = Object.assign({}, data);
      this.editedItem.date = dayjs(this.editedItem.date).format('YYYY-MM-DD HH:mm:ss')
      this.editedItem.due_date = this.editedItem.due_date ? dayjs(this.editedItem.due_date).format('YYYY-MM-DD HH:mm:ss') : dayjs().format('YYYY-MM-DD HH:mm:ss'); 
      this.isSaved = true;
      this.dialog = true;
    },

    addItem() {
      this.items.push({
        product_id: 0,
        item_name:
          this.inputItem.item_name == ""
            ? this.searchQuery
            : this.inputItem.item_name,
        harga_beli: this.inputItem.harga_beli == "" ? 0 : this.inputItem.harga_beli,
        discount: this.inputItem.discount,
        ppn: this.inputItem.ppn,
        qty: this.inputItem.qty
      });

      this.inputItem = {
        product_id: 0,
        item_name: "",
        harga_jual: "",
        discount: "",
        ppn: "",
        qty: ""
      };

      this.searchQuery = "";
      this.selected = null;
      this.item_items = [];
    },

    removeItem(item) {
      if(this.items.length === 1){
        return alert("Tidak bisa menghapus item tunggal pada pengajuan belanja")
      }
      const index = this.items.indexOf(item)
      this.items.splice(index, 1)
    },

    onClickPrint(item) {
      window.open("/print/" + item.id, "_blank");
    },

    async modalDetail(item) {
      this.paid = 0;
      this.editedIndex = this.item_belanja.indexOf(item);
      const response = await this.getUserById(item.user_id);
      const responsePayment = await this.getTransaction(item.id);
      this.setSubmissionId(item.id);
      const responseSubmissionNote = await this.getSubmissionNote;
      this.submissionNotes = responseSubmissionNote;

      this.dataUserInvoice = Object.assign({}, response.data.attributes);
      this.paymentItems = isEmpty(responsePayment.data.attributes)
        ? null
        : Object.assign({}, responsePayment.data.attributes);
      if (this.paymentItems != null) {
        forEach(this.paymentItems, paymentItem => {
          this.paid += Number(paymentItem.jumlah);
        });
      }
      this.dataDetails = Object.assign({}, item);
      this.dialog2 = true;
    },

    async completeSubmission() {
      const payloadUpdate = {
        "id": this.dataDetails.id,
        "status": 'COMPLETED',
        "data": this.dataDetails
      };

      const responseUpdate = await this.updateStatusBelanja(payloadUpdate);
      if (responseUpdate.data.success) {
        this.dataDetails.status = "COMPLETED";
        this.item_belanja[this.editedIndex].status = "COMPLETED";
      }
    },

    async deletePayment(item) {
      if (Number(this.paid) - Number(item.jumlah) < 1) {
        const payloadUpdate = {
          id: this.dataDetails.id,
          status: "APPROVED",
          data: this.dataDetails
        };
        // console.log('payload', payloadUpdate)
        const responseUpdate = await this.updateStatusBelanja(payloadUpdate);
        if (responseUpdate.data.success) {
          this.dataDetails.status = "APPROVED";
          this.item_belanja[this.editedIndex].status = "APPROVED";
        }
      } else {
        const payloadUpdate = {
          id: this.dataDetails.id,
          status: "PARTIAL",
          data: this.dataDetails
        };
        // console.log('payload Bawah', payloadUpdate)
        const responseUpdate = await this.updateStatusBelanja(payloadUpdate);
        if (responseUpdate.data.success) {
          this.dataDetails.status = "PARTIAL";
          this.item_belanja[this.editedIndex].status = "PARTIAL";
        }
      }

      const response = await this.deleteTransaction(item.id);
      // console.log('response', response)
      if (response.data.success) {
        const responsePayment = await this.getTransaction(this.dataDetails.id);
        this.paymentItems = isEmpty(responsePayment.data.attributes)
          ? null
          : Object.assign({}, responsePayment.data.attributes);
        if (this.paymentItems != null) {
          this.paid = 0;
          forEach(this.paymentItems, paymentItem => {
            this.paid += Number(paymentItem.jumlah);
          });
        } else {
          this.paid = 0;
        }
      } else {
        alert("Network Error!");
      }
    },

    editStatusApprove(item) {
      this.note = ''
      this.approval = 'Persetujuan'
      this.editedIndex = this.item_belanja.indexOf(item)
      this.editedItem = Object.assign({}, item)
      if(this.role == 'admin'){
        this.note = ''
        this.saveApproval(this.approval)
      }else{
        this.dialogApproval = true
      }
    },

    editStatusRefuse(item) {
      this.note = ''
      this.approval = 'Penolakan'
      this.editedIndex = this.item_belanja.indexOf(item)
      this.editedItem = Object.assign({}, item)

      if(this.role == 'admin'){
        this.note = ''
        this.saveApproval(this.approval)
      }else{
        this.dialogApproval = true
      }
    },

    editStatusFulfilled(item,status){
      this.editedIndex = this.item_belanja.indexOf(item);
      if(status === "ACCEPT_FULFILLED"){
        this.dialogTextEditedFulfilled = "Apakah anda yakin bahwa pengajuan belanja ini sudah terpenuhi?";
      }else{
        this.dialogTextEditedFulfilled = "Apakah anda yakin bahwa pengajuan belanja ini belum terpenuhi?";
      }
      this.editedFulfilled = status === "ACCEPT_FULFILLED" ? 1 : 0;
      this.editedItem = Object.assign({}, item);
      this.dialogFulfilled = true;
    },
    async savePayment() {
      if (this.jumlahPayment <= Number(this.dataDetails.total) - this.paid) {
        const payload = {
          submission_id: this.dataDetails.id,
          payment_method_id: this.paymentMethodSelected,
          tanggal: this.paymentDate,
          jumlah: this.jumlahPayment
        };
        // console.log("this.dataDetails.total", this.dataDetails.total)
        // console.log("this.paid+this.jumlahPayment", (Number(this.paid)+Number(this.jumlahPayment)))
        if (
          this.dataDetails.total ==
          Number(this.paid) + Number(this.jumlahPayment)
        ) {
          const payloadUpdate = {
            id: this.dataDetails.id,
            status: "PAID",
            data: this.dataDetails
          };
          // console.log('payload', payloadUpdate)
          const responseUpdate = await this.updateStatusBelanja(payloadUpdate);
          if (responseUpdate.data.success) {
            this.dataDetails.status = "PAID";
            this.item_belanja[this.editedIndex].status = "PAID";
          }
        } else {
          const payloadUpdate = {
            id: this.dataDetails.id,
            status: "PARTIAL",
            data: this.dataDetails
          };
          // console.log('payload Bawah', payloadUpdate)
          const responseUpdate = await this.updateStatusBelanja(payloadUpdate);
          if (responseUpdate.data.success) {
            this.dataDetails.status = "PARTIAL";
            this.item_belanja[this.editedIndex].status = "PARTIAL";
          }
        }

        const response = await this.createTransaction(payload);
        // console.log('response', response)
        if (response.data.success) {
          const responsePayment = await this.getTransaction(
            this.dataDetails.id
          );
          this.paymentItems = isEmpty(responsePayment.data.attributes)
            ? null
            : Object.assign({}, responsePayment.data.attributes);
          if (this.paymentItems != null) {
            this.paid = 0;
            forEach(this.paymentItems, paymentItem => {
              this.paid += Number(paymentItem.jumlah);
            });
          }

          this.paymentMethodSelected = "";
          this.paymentDate = "";
          this.jumlahPayment = 0;
          this.closePayment();
        } else {
          alert("Network Error!");
        }
      } else {
        this.showError = true;
      }
    },

    closePayment() {
      this.showError = false;
      this.dialog3 = false;
    },

    closeApproval() {
      this.note = "";
      this.dialogApproval = false;
      this.editedIndex = -1;
    },
    closeFulfilled(){
      this.editedIndex = -1;
      this.dialogFulfilled = false;
    },
    async saveApproval(status) {
      try {
        let statusParam = "";
        if (status == "Persetujuan" && this.role === "admin") {
          statusParam = "APPROVED";  
        } else if(status == "Persetujuan" && this.role === "accountant"){
          statusParam = "PARTIAL APPROVED";
        }else{
          statusParam = "REJECTED";
        }
        this.editedItem.status = statusParam;
        this.editedItem.note = this.note;
        const response = await this.updateBelanja(this.editedItem);
        response.data.attributes[0].total = Number(
          response.data.attributes[0].total
        );
        Object.assign(
          this.item_belanja[this.editedIndex],
          response.data.attributes[0]
        );
      } catch (e) {
        console.log(e);
      }
      this.closeApproval();
    },
    async saveFulfilled(){
      try {
        this.editedItem.is_fulfilled = this.editedFulfilled; 
        const response = await this.updateBelanja(this.editedItem);
        response.data.attributes[0].total = Number(
          response.data.attributes[0].total
        );
        Object.assign(
          this.item_belanja[this.editedIndex],
          response.data.attributes[0]
        );
      } catch (e) {
        console.log(e);
      }
      this.closeFulfilled();
    },

    noteModal(item) {
      this.note = item.note;
      this.dialogNote = true;
    },

    noteModalEdited(item) {
      this.note = item.note;
      if (item.status == "APPROVED") {
        this.approval = "Persetujuan";
      } else {
        this.approval = "Penolakan";
      }
      this.editedIndex = this.item_belanja.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogApproval = true;
    },

    async deleteItem(item) {
      const index = this.item_belanja.indexOf(item);
      if(confirm("Apakah anda yakin menghapus data belanja ini?")){
        await this.deleteBelanja(item.id)
        this.item_belanja.splice(index, 1);
        this.$notify({
          group: 'custom-notification',
          type: 'success',
          title: 'Success!',
          text: 'Draft berhasil dihapus'
        });
      }
    },

    async close() {
      this.items = [];
      this.item_belanja = orderBy(
        this.item_belanja,
        ["id", "status"],
        ["desc", "DRAFT"]
      );
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
      this.dialog = false;
      this.userFound = false
      this.newUser = false
      this.editedItemUser = Object.assign({}, this.defaultItemUser)
      this.inputSearch = ""
    },

    async save() {
      let total = 0;
      forEach(this.items, item => {
        if (
          item.discount != "" &&
          item.ppn != "" &&
          item.discount != 0 &&
          item.ppn != 0
        ) {
          total =
            total +
            Number(item.qty) *
              Number(item.harga_beli) *
              (1 - Number(item.discount) / 100) *
              (1 + Number(item.ppn) / 100);
        } else if (item.discount != "" && item.discount != 0) {
          total =
            total +
            Number(item.qty) *
              Number(item.harga_beli) *
              (1 - Number(item.discount) / 100);
        } else if (item.ppn != "" && item.ppn != 0) {
          total =
            total +
            Number(item.qty) *
              Number(item.harga_beli) *
              (1 + Number(item.ppn) / 100);
        } else {
          total = total + Number(item.qty) * Number(item.harga_beli);
        }

        item.ppn = item.ppn == "" ? 0 : item.ppn;
        item.discount = item.discount == "" ? 0 : item.discount;
      });
      this.editedItem.total = total;

      if(this.editedItem.due_date < this.editedItem.date) {
        return this.$notify({
          group: 'custom-notification',
            type: 'error',
            title: 'Error!',
            text: 'Batas waktu tidak boleh lebih kecil daripada tanggal'
          });
      }
      this.editedItem.date = dayjs(this.editedItem.date).format("YYYY-MM-DD HH:mm:ss");
      this.editedItem.due_date = dayjs(this.editedItem.due_date).format("YYYY-MM-DD HH:mm:ss");
      if (this.editedIndex > -1) {
        try {
          this.editedItem.items = this.items;
          this.editedItem.note = null;
          const response = await this.updateBelanja(this.editedItem);
          this.editedItem.total = Number(this.editedItem.total);
          response.data.attributes[0].total = Number(
            response.data.attributes[0].total
          );
          forEach(response.data.attributes[0].items, item => {
            item.harga_beli = Number(item.harga_beli);
            item.qty = Number(item.qty);
            item.discount = Number(item.discount);
            item.ppn = Number(item.ppn);
          });
          Object.assign(
            this.item_belanja[this.editedIndex],
            response.data.attributes[0]
          );
        } catch (e) {
          console.log(e);
        }
      } else {
        let partner_id
        if(this.newUser){
            this.editedItemUser.username = this.editedItemUser.name.toLowerCase().replace(/\s/g, '')
            this.editedItemUser.password = (new Date().getTime()).toString() + (Math.floor((Math.random() * 10000000) + 1)).toString()
            let responseUser = await this.createUserSubmission(this.editedItemUser)
            if(responseUser.data.success){
                this.$notify({
                  group: 'custom-notification',
                  type: 'success',
                  title: 'Success!',
                  text: 'Berhasil Membuat Vendor Baru'
                });
                partner_id = responseUser.data.attributes.user.id
            }else{
                return
            }
        }else if(this.userFound){
            partner_id = this.editedItemUser.id
        }else{
            partner_id = this.userLogin.id  
        }

        this.editedItem.partner_id = partner_id
        this.editedItem.items = this.items;
        let response = ""
        try{
          response = await this.createBelanja(this.editedItem);
        }catch(e){
          console.log(e)
        }
        this.editedItem.total = Number(response.data.attributes[0].total);
        this.editedItem.date = response.data.attributes[0].date;
        this.editedItem.status = response.data.attributes[0].status;
        response.data.attributes[0].total = Number(
          response.data.attributes[0].total
        );
        forEach(response.data.attributes[0].items, item => {
          item.harga_beli = Number(item.harga_beli);
          item.qty = Number(item.qty);
          item.discount = Number(item.discount);
          item.ppn = Number(item.ppn);
        });
        this.item_belanja.splice(0, 0, response.data.attributes[0]);
      }
      this.isSaved = true;
      this.close();
    },

    editableSave() {
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Data saved";
    },
    editableCancel() {
      // this.snack = true;
      // this.snackColor = "error";
      // this.snackText = "Canceled";
    },
    editableOpen() {
      // this.snack = true;
      // this.snackColor = "info";
      // this.snackText = "Dialog edit opened";
    },
    editableClose() {
      // console.log("Dialog closed");
    },
    submissionNoteClose() {
      this.noteModalVisible = false;
    },
    async submissionNoteSave() {
      const payload = {
        "submission_id": this.dataDetails.id,
        "comment": this.newNote.comment,
        "date": this.newNote.date
      };
      try{
        await this.createSubmissionNote({
          ...payload
        });
        this.$notify({
          group: 'custom-notification',
          type: 'success',
          title: 'Success!',
          text: 'Sukses menambahkan catatan!'
        });
        this.submissionNotes.push({
          ...payload,
          user: this.userLogin
        });
        this.noteModalVisible = false;
      }catch(e){
        console.log(e)
      }
    },
    async handleDeleteSubmissionNote(id,index){
      this.submissionNotes.splice(index, 1);
      await this.deleteSubmissionNote(id);
      this.$notify({
          group: 'custom-notification',
          type: 'success',
          title: 'Success!',
          text: 'Sukses menghapus catatan!'
      });
    },
    async changeFilter(){
      let payload = {}
      if(this.selectedStatus){
        payload.condition = {
          status : this.selectedStatus,
          type : 'PENGELUARAN',
          category_id : 0
        }
      }
      if(this.selectedDateFrom && this.selectedDateTo){
        payload.condition = {
          type : 'PENGELUARAN',
          category_id : 0
        }
        payload.between = {
          from : this.selectedDateFrom,
          to : this.selectedDateTo
        }
      }

      this.item_belanja = []
      let dataItem = {}
      if(!isEmpty(payload)){
        const response = await this.filterBelanja(payload)
        dataItem = response.data
      }else{
        dataItem = await this.dataBelanja  
      }      

      this.totalBelanja = dataItem.total
      forEach(dataItem.submission,  (data, index) => {
        forEach(data.items, (subItem, i) => {
          data.items[i].harga_jual = Number(subItem.harga_jual)
          data.items[i].qty = Number(subItem.qty)
          data.items[i].discount = Number(subItem.discount)
          data.items[i].ppn = Number(subItem.ppn)
        })
        this.item_belanja.push(data)
      })
    },

    clearFilterStatus(){
      this.selectedStatus = null
    }
  }
};
</script>